import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const createKbFeedback = createAsyncThunk(
    'kbFeedback/createKbFeedback',
    async (feedbackData, { getState, rejectWithValue }) => {
        try {
            const { loginToken } = getState();
            const authToken = loginToken?.response?.token;

            const response = await axios.post(
                `${ROOT_URL}/kb/feedback-internal`,
                feedbackData,
                {
                    headers: {
                        'Authorization': `Bearer ${authToken}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            return response.data;
        } catch (error) {
            console.error("Error adding feedback:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const initialState = {
    loading: false,
    error: null,
    success: false,
    data: null,
};

const createKbFeedbackSlice = createSlice({
    name: 'createKbFeedback',
    initialState,
    reducers: {
        resetCreateKbFeedbackState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
            state.data = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createKbFeedback.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(createKbFeedback.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.data = action.payload;
            })
            .addCase(createKbFeedback.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.success = false;
            });
    }
});

export const { resetCreateKbFeedbackState } = createKbFeedbackSlice.actions;
export default createKbFeedbackSlice.reducer;
